import { PapiEditorText } from '@wix/da-papi-types';
import { getFeature } from '../../server/features/helpers';
import { SchemaVersion } from '../../server/types';
import { JSONContent } from '@tiptap/react';

export function isInsideEditor(element: Element) {
  if (typeof document === 'undefined') {
    return;
  }

  return element.closest('.editor-wrapper');
}

export function isEditorTextEmpty(editorText: PapiEditorText) {
  // legacy editor data
  if (editorText.html.type === 'writer') {
    return !editorText.html.markup;
  }

  let isEmpty;
  const isEmptyFeature = getFeature(
    'IS_EMPTY_FEATURE',
    editorText.html.features
  );
  if (isEmptyFeature) {
    isEmpty = isEmptyFeature && isEmptyFeature.data.isEmpty;
  } else {
    const wordCountFeature = getFeature(
      'WORD_COUNT_FEATURE',
      editorText.html.features
    );
    isEmpty = wordCountFeature && wordCountFeature.data.chars === 0;
  }

  return isEmpty;
}

export function getWordCount(editorText: PapiEditorText) {
  if (!editorText?.html?.features) {
    return 0;
  }
  const wordCountFeature = getFeature(
    'WORD_COUNT_FEATURE',
    editorText.html.features
  );
  if (!wordCountFeature) {
    return 0;
  }
  return wordCountFeature.data.words || 0;
}

export function fromPlainText(text) {
  const doc = {
    version: SchemaVersion.V1,
    document: {
      type: 'doc',
      content: text
        ? [
            {
              type: 'paragraph',
              content: [
                {
                  type: 'text',
                  text: text,
                },
              ],
            },
          ]
        : [],
    },
  };
  return {
    excerpt: text,
    html: {
      type: 'tiptap',
      markup: JSON.stringify(doc),
      features: '[]',
    },
  };
}

export function emptyDocument() {
  return {
    version: SchemaVersion.V1,
    document: {
      type: 'doc',
      content: [
        {
          type: 'paragraph',
        },
      ],
    },
  };
}

export function fromDocument(document: JSONContent) {
  const doc = {
    version: SchemaVersion.V1,
    document: document,
  };
  return {
    excerpt: '',
    html: {
      type: 'tiptap',
      markup: JSON.stringify(doc),
      features: '[]',
    },
  };
}
